import { StringMap } from '@naturalcycles/js-lib'
import { mixpanelService } from '@src/srv/mixpanel.service'
import { useEffect } from 'react'

export function useLoadStats(): void {
  useEffect(() => {
    const timeMounted = Date.now()

    const timeOnClientEntryString = sessionStorage.getItem('time:onClientEntry')
    const timeHeadScriptString = sessionStorage.getItem('time:headScript')

    const timeOnClientEntry = Number(timeOnClientEntryString) || undefined
    const timeHeadScript = Number(timeHeadScriptString) || undefined

    const areTimesDefined = timeOnClientEntry && timeHeadScript

    const data: StringMap<number> = {
      timeMounted,
      timeOnClientEntry,
      timeHeadScript,
      ...(areTimesDefined && {
        'Diff - OnClientEntry to page mount': timeMounted - timeOnClientEntry,
        'Diff - head script to page mount': timeMounted - timeHeadScript,
        'Diff - head script to OnClientEntry': timeOnClientEntry - timeHeadScript,
      }),
    }

    mixpanelService.track('Web load times', data)

    // While we can see the mixpanel message in the console, we can't while throttling because the
    // console being open marks us as a bot.
    if (process.env['GATSBY_ENV'] !== 'production') {
      console.log('Web load times', data)
    }
  }, [])
}
